import { render, staticRenderFns } from "./plmProject.vue?vue&type=template&id=522ac648&scoped=true"
import script from "./plmProject.vue?vue&type=script&lang=js"
export * from "./plmProject.vue?vue&type=script&lang=js"
import style0 from "./plmProject.vue?vue&type=style&index=0&id=522ac648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ac648",
  null
  
)

export default component.exports